import React, { useEffect, useState } from "react"
import { Helmet } from "react-helmet";
import Layout from "@Components/layout";
import { Link } from "@StarberryUtils"
import axios from "axios"
import { graphql } from 'gatsby'
import GoogleReview from "../images/google-reviews-color.png"
import { Container, Row, Col } from 'react-bootstrap';
import { uknumberformatFront } from "@Components/common/common-functions"
import wordsToNumbers from "words-to-numbers"
import ReactMarkdown from "react-markdown"
import VideoModal from '@Components/Play/VideoModal';
import ImageRenderer from "../Components/ImageRenderer/ImageRenderer"
import ContactForm from "@Components/forms/general-enquiry"
import SEO from "@Components/seo";
import { useLocation } from "@reach/router";

const OfficeDetails = (props) => {

  const office = props.data.glstrapi.office;
  const isContactForm = props.pageContext.contactForm;
  const isContactformPage = props.pageContext.isContactformPage;
  const location =useLocation();
  const currentPath = location.pathname.replace(/\/+$/, ''); // remove trailing slashes
  const contactPath = `${currentPath}/contact`;

  const [testimonials, setTestimonials] = useState([])
  const [isClient, setClient] = useState(false)

  const strapiconfig = {
    headers: {
      Authorization: `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
    },
  }

  const getitems = async url => {
    try {
      const { data } = await axios.get(url, strapiconfig) // could be from env files
      setTestimonials(data)
    } catch (error) {
      // cache it if fail/error;
      console.error(error)
    }
  }
  useEffect(() => {
    let url = `${process.env.GATSBY_STRAPI_SRC}/stb-google-reviews/google-review-reviews`
    getitems(url)
    setClient(true)
  }, [])
  var testimonial_count = testimonials ? testimonials.length : 0
  var rating_count = 0
  testimonials &&
    testimonials.length > 0 &&
    testimonials.map((item, ind) => {
      rating_count += parseInt(wordsToNumbers(item.starRating))
    })
  var rating_avg = rating_count / testimonial_count
  let title = "Contact Bentley Hurst"
  if (!isContactformPage) {
  title = location.pathname.includes("contact-hale-estate-agents")
  ? "Contact Hale Estate Agents"
  : location.pathname.includes("contact-manchester-estate-agents")
  ? "Contact Manchester Estate Agents"
  : "Contact Bentley Hurst";
  }
  return (
    <Layout css={true} breadCrumPage={title} class="static" headerClass={"white"} breadCrumAlias={'contact'} type="contact">
        <SEO title={office ? office.Meta_Title : ''} description={office ? office.Meta_Description : ''} url={props.location.href} />
       <Helmet
              bodyAttributes={{
                class: `office-detail-template`
              }}
            />
      <div className="contact-page">
        <div className="contack-image">
          <ImageRenderer renderer="pic-src" ImageSrc={office.Image} altText={office.Name + ' - Bentley Hurst'} ggfx_results={office.ggfx_results} strapi_id={office.id} imagename="office.Image.bannerimg" />
          {!isContactformPage &&
            <VideoModal video_url={office.Video_URL} />
          }

        </div>

        <Container>
          {!isContactForm &&
            <>
            <Helmet>
              <script type="application/ld+json">{`{
                    "@context": "http://schema.org",
                    "@type": "Product",
                    "name" : ${office.Name},
                    "image": "https://www.bentleyhurst.co.uk/images/mail-logo.png",
                    "url": "https://www.bentleyhurst.co.uk/office/${office.Slug}",
                    "description" : "The ${office.Name} estate agents are happy to help you find fantastic properties in the area. Just call us, it's the first step to your dream home",
                    "brand" : {
                        "@type" : "Brand",
                        "name" : "Bentley Hurst - ${office.Name} Estate Agents",
                        "image" : "https://www.bentleyhurst.co.uk/images/mail-logo.png"
                    },
                    "aggregateRating": {
                        "@type": "AggregateRating",
                        "ratingValue": "4.9",
                        "bestRating": "5",
                        "ratingCount": "321"
                    } 
                }`}</script>
            </Helmet>
            </>
          }
          <Row>
            {isContactForm &&
              <Col lg="7">
                <div className=" contact-detail d-lg-block padding-right"> 
                  <h1 className="contact-h1">{title}</h1>
                  <ContactForm showVideo={true} to_email_id={isContactformPage ? process.env.MAIL_TO : office?.Email} isContactformpage={true} />
                </div>

              </Col>
            }
            {!isContactForm &&
              <Col lg="7">
                <div className=" contact-detail d-lg-block padding-right">
                  <h1 className="contact-h1">Contact Bentley Hurst</h1>
                  <a href={"tel:" + office?.Phone} className="phone">
                    {office?.Phone}
                  </a>
                  <Link to={"contact"} className="email">
                    {office?.Email}
                  </Link>
                  <Link to={"/book-a-valuation/"} className="btn btn-primary margin-right">
                    Book a Valuation
                  </Link>
                  {/* <Link to={contactPath} className="btn btn-primary margin-right">
                   Contact Us
                  </Link> */}

                  <div className="google-review-block">
                    <div className="">
                      <img
                        className="disable-max-width"
                        src={GoogleReview}
                        alt="Google Reviews Bentley Hurst"
                      />
                    </div>
                    <p>
                      Rated{" "}
                      <strong>
                        {rating_avg ? parseFloat(rating_avg.toFixed(1)) : "4.8"}/5
                      </strong>{" "}
                      from {testimonial_count ? testimonial_count+'+' : "377+"} Customer
                      Reviews.
                    </p>
                  </div>

                  <table>
                    <tr>
                      <td>
                        <label>Address:</label>
                      </td>
                      <td>
                        <div className="rich-text-editer-block">

                          <ReactMarkdown
                            source={office?.Address}
                            allowDangerousHtml
                          />
                          <a href="https://maps.app.goo.gl/KAJExtmm4cmBRUrX7">View on a Map</a>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>Opening Hours:</label>
                      </td>
                      <td>
                        <div className="rich-text-editer-block">
                          <ReactMarkdown
                            source={office?.Opening_Hours}
                            allowDangerousHtml
                          />
                        </div>
                      </td>
                    </tr>
                  </table>


                  <div className="contact-persion-blk">
                    {office.Speak_with.map((node, index) => {
                      return (
                        <div className="negotiator d-flex align-items-center">
                          <figure>
                            <img
                              src={node?.Image?.url}
                              alt={node?.Image?.alternativeText}
                            />
                          </figure>
                          <div className="info">
                            <strong className="name">{node?.Name}</strong>
                            <p className="post">{node?.Designation}</p>
                            <a
                              className="contact-no"
                              href={"tel:" + uknumberformatFront(node?.Phone)}
                            >
                              {uknumberformatFront(node?.Phone)}
                            </a>
                          </div>
                        </div>
                      )
                    })}
                  </div>

                </div>
              </Col>
            }


          </Row>
        </Container>
      </div>
    </Layout>
  );
}
export default OfficeDetails



export const pageQuery = graphql`
          query OfficeQuery($id: ID!) {
            glstrapi {
            office(id: $id, publicationState: LIVE) {
            id
            Name
            Slug
            Email
            Phone
             
            Address
            Meta_Title
            Meta_Description
            Opening_Hours
            Video_URL
            ggfx_results {
              transforms
              src_url
              src_cftle
            }
            Image {
                url
                alternativeText
            }
            Speak_with {
              Image {
                url
                alternativeText
              }
              Designation
              Name
              Phone
            }
          }
       } 
  }
          `
